import { Module } from '@nestjs/common';
import { AuditModule } from 'src/audit/audit.module';
import { MiddlewareSifenModule } from 'src/middleware-sifen/middleware-sifen.module';
import { PersonasModule } from 'src/personas/personas.module';
import { NotaRemisionController } from './nota-remision.controller';
import { NotaRemisionPayloadModule } from './nota-remision-payload.module';
import { NotaRemisionService } from './nota-remision.service';
import { NotaRemisionValidacionService } from './nota-remision-validacion.service';
import { ReversionRemisionModule } from './reversion-remision.module';

@Module({
  imports: [MiddlewareSifenModule, NotaRemisionPayloadModule, PersonasModule, AuditModule, ReversionRemisionModule],
  controllers: [NotaRemisionController],
  providers: [NotaRemisionService, NotaRemisionValidacionService],
  exports: [NotaRemisionService],
})
export class NotaRemisionModule {}
